export default {
      path: '/barrage-wall',
      component: () => import('./BarrageWall'),
      meta: {
        title: '我要上墙',
        designWidth:750,
        expireIn: 'Tue Mar 10 2020 10:25:33 GMT+0800 (GMT+08:00)',
        axiosConfig: {
          baseURL: '',
          withCredentials: false,
          postContentType: 'FormData'
        }
      }
    }
